// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminSecurity\AdminSecurity.js
// Версия: 2.0.0 - Light theme, real data
// Дата: 04.12.2025

import React, { useState, useEffect } from 'react';
import './AdminSecurity.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const AdminSecurity = () => {
  const [ipBlocks, setIpBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newIP, setNewIP] = useState('');
  const [newReason, setNewReason] = useState('');
  const [showForm, setShowForm] = useState(false);

  const token = localStorage.getItem('authToken');

  useEffect(() => { fetchIPBlocks(); }, []);

  const fetchIPBlocks = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/admin/security/ip-blocklist`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setIpBlocks(data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBlockIP = async () => {
    if (!newIP.trim()) {
      alert('Введите IP адрес');
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/admin/security/ip-blocklist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ip_address: newIP.trim(),
          reason: newReason.trim() || 'Заблокировано администратором'
        })
      });

      if (res.ok) {
        setNewIP('');
        setNewReason('');
        setShowForm(false);
        fetchIPBlocks();
      } else {
        const err = await res.json();
        alert('Ошибка: ' + (err.error || 'Unknown'));
      }
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  const handleUnblockIP = async (id) => {
    if (!window.confirm('Разблокировать этот IP?')) return;

    try {
      await fetch(`${API_URL}/api/admin/security/ip-blocklist/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      fetchIPBlocks();
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  if (loading) return <div className="admin-loading">Загрузка...</div>;

  return (
    <div className="admin-ip-blocks">
      <div className="admin-page-header">
        <h1 className="admin-page-title">🚫 IP Блокировки</h1>
        <div className="admin-page-actions">
          <button className="admin-btn admin-btn-primary" onClick={() => setShowForm(!showForm)}>
            {showForm ? '✕ Отмена' : '➕ Заблокировать IP'}
          </button>
          <button className="admin-btn" onClick={fetchIPBlocks}>🔄</button>
        </div>
      </div>

      {/* Stats */}
      <div className="ip-stats">
        <div className="ip-stat">
          <span className="ip-stat-value">{ipBlocks.length}</span>
          <span className="ip-stat-label">Заблокировано</span>
        </div>
        <div className="ip-stat orange">
          <span className="ip-stat-value">{ipBlocks.filter(b => !b.expires_at).length}</span>
          <span className="ip-stat-label">Навсегда</span>
        </div>
        <div className="ip-stat blue">
          <span className="ip-stat-value">{ipBlocks.filter(b => b.expires_at).length}</span>
          <span className="ip-stat-label">Временно</span>
        </div>
      </div>

      {/* Add Form */}
      {showForm && (
        <div className="ip-form">
          <h3>🔒 Заблокировать IP адрес</h3>
          <div className="ip-form-fields">
            <input
              type="text"
              placeholder="IP адрес (например: 192.168.1.100)"
              value={newIP}
              onChange={e => setNewIP(e.target.value)}
              className="ip-input"
            />
            <input
              type="text"
              placeholder="Причина (опционально)"
              value={newReason}
              onChange={e => setNewReason(e.target.value)}
              className="ip-input"
            />
            <button className="admin-btn admin-btn-danger" onClick={handleBlockIP}>
              🚫 Заблокировать
            </button>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="admin-card">
        {ipBlocks.length === 0 ? (
          <div className="admin-empty">✅ Нет заблокированных IP адресов</div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>IP адрес</th>
                <th>Причина</th>
                <th>Заблокирован</th>
                <th>Истекает</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {ipBlocks.map(block => (
                <tr key={block.id}>
                  <td><code className="ip-code">{block.ip_address}</code></td>
                  <td className="ip-reason">{block.reason || '-'}</td>
                  <td className="ip-date">{formatDate(block.created_at)}</td>
                  <td className="ip-expires">
                    {block.expires_at ? (
                      <span className="expires-badge">{formatDate(block.expires_at)}</span>
                    ) : (
                      <span className="permanent-badge">∞ Навсегда</span>
                    )}
                  </td>
                  <td>
                    <button 
                      className="admin-btn admin-btn-sm admin-btn-success"
                      onClick={() => handleUnblockIP(block.id)}
                    >
                      🔓 Разблокировать
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminSecurity;